import { useState, useEffect } from 'react';

export const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      // Check for touch capability
      const touchCapable = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      // Check for mobile user agent
      const mobileRegex = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i;
      const isMobileUA = mobileRegex.test(navigator.userAgent);
      
      // Check for small screen size
      const isSmallScreen = window.innerWidth < 1024;
      
      // Consider it mobile if it has touch AND (is mobile UA OR small screen)
      const mobile = touchCapable && (isMobileUA || isSmallScreen);
      
      setIsMobile(mobile);
      setIsTouch(touchCapable);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return { isMobile, isTouch };
};